import React from 'react'

export default function GroupChatPreview({data, onModalClose}) {
    let html = ""
    if (data.groupChatData) {
        html = data.groupChatData.html
    }

    return <div className="modal preview-modal" role="dialog" tabIndex="-1"
                onClick={() => {
                    onModalClose ? onModalClose() : alert("No modal close action available.")
                }}>
        <div className="modal-dialog" role="document">
            <div className="modal-content" onClick={(event) => {
                event.stopPropagation()
            }}>
                <div className="modal-header">
                    <div className="modal-title">
                        {data.title}
                    </div>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                          onModalClose ? onModalClose() : alert("No modal close action available.")
                      }}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    <div dangerouslySetInnerHTML={{__html: html}}/>
                </div>
                <div className="modal-footer">
                    <a className="btn-ueg"
                       href="https://ueg.flave.world/admin/quick_video_rooms/public?title=Group-Chat&amp;jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJmbGF2ZSIsInN1YiI6ImZsYXZlLndvcmxkIiwiYXVkIjoiZmxhdmUiLCJleHAiOjE2MDIyNDE0NTMsInJvb20iOiIqIiwibW9kZXJhdG9yIjpmYWxzZX0.Re9nJ5dt9smrclJGhWWkGCmwSqDZha3oI93eYokoNjM">Join
                        the Group Chat</a>
                </div>
            </div>
        </div>
    </div>;
}
